import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withNamespaces } from "react-i18next";

import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
} from "../../store/actions";

import { isRWA, isTechnician } from "../../pages/Authentication/userMetaData";
import LKDashboardImg from "../../assets/images/LK_Icons/LK_White_Dashboard.svg";
import LKTransactionImg from "../../assets/images/LK_Icons/LK_White_Dashboard.svg";
import LKUserImg from "../../assets/images/LK_Icons/LK_White_User.svg";
import LKLocationImg from "../../assets/images/LK_Icons/LK_White_Location Pin.svg";
import LKCustomerCareImg from "../../assets/images/LK_Icons/LK_White_Customer Care.svg";
import LKBillingImg from "../../assets/images/LK_Icons/LK_White_Billing.svg";
import LKChargerImg from "../../assets/images/LK_Icons/LK__EV charger_White.svg";
import LKStackImg from "../../assets/images/LK_Icons/stack-line.svg";
// import LKStackImg from "../../assets/images/LK_Icons/LK_transaction_history_white.svg";
import LKReportImg from "../../assets/images/LK_Icons/LK_White_Report.svg";
import LKProjectImg from "../../assets/images/LK_Icons/LK_white_Project.png";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: props.user,
    };
  }

  componentDidMount() {
    this.initMenu();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.type !== prevProps.type) {
        this.initMenu();
      }
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    var matchingMenuItem = null;
    var ul = document.getElementById("side-menu");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{this.props.t("Menu")}</li>

            {/* <li>
              <Link to="/cms-customers" className="waves-effect">
                <i className="ri-user-search-line"></i>
                <span className="badge badge-pill badge-success float-right"></span>
                <span className="ml-1">{this.props.t("Customers")}</span>
              </Link>
            </li> */}

            {/* dashboard */}
            {!isTechnician(this.state.user) && (
              <li>
                <Link to="/dashboard" className="waves-effect">
                  {/* <i className="ri-dashboard-line"></i> */}
                  <img
                    src={LKDashboardImg}
                    alt="dashboardImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  {/* <span className="badge badge-pill badge-success float-right">3</span> */}
                  <span className="ml-1">{this.props.t("Dashboard")}</span>
                </Link>
              </li>
            )}
            {/* charger */}
            {!isTechnician(this.state.user) && (
              <li>
                <Link to="/#" className="has-arrow waves-effect">
                  <img
                    src={LKChargerImg}
                    alt="userImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  <span className="ml-1 wave-effect">
                    {this.props.t("Chargers")}
                  </span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="cms-chargers">{this.props.t("Chargers")}</Link>
                  </li>
                  <li>
                    <Link to="cms-add-chargers">
                      {this.props.t("Add Charger")}
                    </Link>
                  </li>
                  {/* {isTechnician(this.state.user) && (
                  <li>
                    <Link to="cms-firmware-management">{this.props.t("Advanced")}</Link>
                  </li>
                )} */}
                </ul>
              </li>
            )}
            {/* transaction */}
            {!isTechnician(this.state.user) && (
              <li>
                <Link to="cms-transactions">
                  {/* <i className="ri-stack-line" style={{color:"#EFEFEF"}}></i> */}
                  <img
                    src={LKStackImg}
                    alt="userImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  <span className="ml-1">{this.props.t("Transactions")}</span>
                </Link>
              </li>
            )}

            {/* Host */}
            {!isTechnician(this.state.user) && !isRWA(this.state.user) && (
              <li>
                <Link to="/#" className="has-arrow waves-effect">
                  <img
                    src={LKUserImg}
                    alt="userImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  {/* <i className="ri-user-line"></i> */}
                  <span className="ml-1">{this.props.t("Host")}</span>
                </Link>

                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="cms-host-details">
                      {this.props.t("View Host")}
                    </Link>
                    {/* <Link to="/#" style={{ color: "grey" }} onClick={(e) => e.preventDefault()}>
                      {this.props.t("View Host")}
                    </Link> */}
                  </li>
                  <li>
                    <Link to="cms-add-host">{this.props.t("Add Host")}</Link>
                    {/* <Link to="/#" style={{ color: "grey" }} onClick={(e) => e.preventDefault()}>
                      {this.props.t("Add Host")}
                    </Link> */}
                  </li>
                </ul>
              </li>
            )}

            {/* Users */}
            {!isTechnician(this.state.user) && (
              <li>
                <Link to="cms-users">
                  {/* <i className="ri-user-line"></i> */}
                  <img
                    src={LKUserImg}
                    alt="userImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  <span className="ml-1">{this.props.t("Users")}</span>
                </Link>
              </li>
            )}

            {/* <li><Link to="cms-user-details">{this.props.t('User Details')}</Link></li> */}
            {/* location */}
            {!isTechnician(this.state.user) && (
              <li>
                <Link to="/#" className="has-arrow waves-effect">
                  {/* <i className="ri-map-pin-line"></i> */}
                  <img
                    src={LKLocationImg}
                    alt="locationImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  <span className="ml-1">{this.props.t("Locations")}</span>
                </Link>

                <ul className="sub-menu" aria-expanded="false">
                  {/* {!isTechnician(this.state.user) && (
                  <li>
                    <Link to="cms-locations">{this.props.t("Local")}</Link>
                  </li>
                )} */}
                  {/* <li><Link to="cms-charger-detail">{this.props.t('Charger Details')}</Link></li> */}

                  {/* <li><Link to="cms-user-details">{this.props.t('User Details')}</Link></li> */}
                  <li>
                    <Link to="cms-multi-locations">
                      {this.props.t("View Location")}
                    </Link>
                  </li>

                  <li>
                    <Link to="cms-add-locations">
                      {this.props.t("Add Location")}
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            {/* Reports */}
            {!isTechnician(this.state.user) && (
              <li>
                <Link to="/cms-report" className="waves-effect">
                  {/* <i className="ri-dashboard-line"></i> */}
                  <img
                    src={LKReportImg}
                    alt="recordImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  {/* <span className="badge badge-pill badge-success float-right">3</span> */}
                  <span className="ml-1">{this.props.t("Reports")}</span>
                </Link>
              </li>
            )}
            {/* customer care */}
            {!isTechnician(this.state.user) && (
              <li>
                <Link
                  to={{
                    pathname: "/customer-care",
                  }}
                  className="waves-effect"
                >
                  {/* <i className="ri-customer-service-2-line"></i> */}
                  <img
                    src={LKCustomerCareImg}
                    alt="customerCareImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  <span className="ml-1">{this.props.t("Customer Care")}</span>
                </Link>
              </li>
            )}
            {/* Accounts and Billing */}
            {/* {!isTechnician(this.state.user) && (
              <li>
                <Link
                  to={{
                    pathname: "https://dashboard.razorpay.com/app/dashboard",
                  }}
                  target="_blank"
                  className="waves-effect"
                >
                
                  <img src={LKBillingImg} alt="customerCareImg" style={{ width: "16px", height: "16px", marginRight: "10px" }} />

                  <span className="badge badge-pill badge-success float-right"></span>
                  <span className="ml-1">{this.props.t("Accounts and Billing")}</span>
                </Link>
              </li>
            )} */}

            {/* Technician */}
            {/* Chargers */}
            {isTechnician(this.state.user) && (
              <li>
                <Link to="cms-chargers">
                  <img
                    src={LKChargerImg}
                    alt="chargerImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  <span className="ml-1">{this.props.t("Chargers")}</span>
                </Link>
              </li>
            )}

            {/* Location */}
            {isTechnician(this.state.user) && (
              <li>
                <Link to="cms-multi-locations">
                  <img
                    src={LKLocationImg}
                    alt="locationImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  <span className="ml-1">{this.props.t("Locations")}</span>
                </Link>
              </li>
            )}

            {/* Key Accounts */}
            {isTechnician(this.state.user) && (
              <li>
                <Link to="cms-tech-projects">
                  <img
                    src={LKProjectImg}
                    alt="locationImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  <span className="ml-1">{this.props.t("Key Accounts")}</span>
                </Link>
              </li>
            )}

            {/* Logs */}
            {isTechnician(this.state.user) && (
              // <li>
              //   {/* http://app.iqlabs.io:3000/login */}
              //   <Link to="cms-multi-locations">
              //     <img src={LKReportImg} alt="reportImg" style={{ width: "16px", height: "16px", marginRight: "10px" }} />
              //     <span className="ml-1">{this.props.t("Logs")}</span>
              //   </Link>
              // </li>
              <li>
                <a
                  href="http://app.iqlabs.io:3000"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={LKReportImg}
                    alt="reportImg"
                    style={{
                      width: "16px",
                      height: "16px",
                      marginRight: "10px",
                    }}
                  />
                  <span className="ml-1">{this.props.t("Logs")}</span>
                  <i class="ri-arrow-right-up-fill"></i>
                </a>
              </li>
            )}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  //return { ...state.Layout };
  return {
    Layout: state.Layout,
    user: state.Login.user,
  };
};

export default withRouter(
  connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader,
  })(withNamespaces()(SidebarContent))
);
